import ConfigView  from 'scripts/defa/basic/view-config-view';
import SuccessView from 'scripts/defa/basic/view-success-view';
import LegacyFlow  from 'scripts/defa/legacy/view-legacy-flow';
import Unit        from 'scripts/defa/units/model-unit';
import User        from 'scripts/defa/users/model-user';

/**
 * defa.controllers.LegacyController
 * The controller for legacy functionality in Simplify.
 * @version 1.2.2
 */
import Controller  from 'scripts/poppet/controller';

const channelLayout = Bb.Radio.channel( 'layout' ),
	channelNav    = Bb.Radio.channel( 'nav' ),
	channelUser   = Bb.Radio.channel( 'user' );

const channel = Bb.Radio.channel( 'objects' );

const LegacyController = Controller.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------
	
	/**
	 * Initiates the migrate old devices setup.
	 * @void
	 */
	showMigrate: function ( id ) {
		
		// user         : the currently active user,
		// selectedUser : the user that will be used for migration.
		id = ( isNaN( id ) )
			 ? null
			 : id;
		
		let user         = channelUser.request( 'model' ),
			selectedUser = false,
			options      = {};
		
		// set userId if it exists
		options.userId = id;
		
		// legacy migrate for support when userId is set.
		if ( options.userId && channelUser.request( 'is:logged:in' ) && user.hasRoles( [ 'TECHNICAL_SUPPORT', ] ) ) {
			
			selectedUser = new User( {
				id: options.userId,
			} );
			
			let configView = new ConfigView( {
				context: 'wait',
			} );
			
			channelLayout.request( 'root' ).showChildView( 'main', configView );
			
			this.listenTo( selectedUser, 'sync', function () {
				this._showLegacyFlow( _.extend( options, {
					first       : true,
					context     : 'migrate',
					selectedUser: selectedUser,
				}
				)
				);
			} );
			
			this.listenTo( selectedUser, 'error', function () {
				channelLayout.trigger( 'error', { model: selectedUser } );
			} );
			
			selectedUser.fetch();
			
			// normal legacyMigration:
		} else {
			// remove identifier from url if set
			if ( id ) {
				channelNav.trigger( 'legacy:migrate', [], {} );
			}
			
			// continue with normal login.
			this._showLegacyFlow( {
				first  : true,
				context: 'migrate',
			} );
		}
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Displays the legacyflow with the options set earlier.
	 * @param {object} options  The legacy migrate options for the flow view.
	 * @void
	 */
	_showLegacyFlow: function ( options ) {
		
		let legacyFlow = new LegacyFlow( _.extend( options, {
			closeLink: {
				event: 'app:root',
			},
		} ) );
		
		// migration listener
		this.listenTo( legacyFlow, 'migrate', function ( legacyUser, legacyUnit, selectedUser, owner ) {
			
			// show config migrate view
			let configView = new ConfigView( {
				context: 'migrate',
			} );
			channelLayout.request( 'root' ).showChildView( 'main', configView );
			
			// migrate error
			this.listenToOnce( legacyUnit, 'error', function ( response ) {
				this.stopListening( legacyUnit );
				channelLayout.trigger( 'error', response.responseJSON );
			} );
			
			// migrate success
			this.listenToOnce( legacyUnit, 'migrated', function ( responseUnit ) {
				
				this.stopListening( legacyUnit );
				
				// cleanup, selectedUser, unit, legacy...
				let unit = new Unit( responseUnit );
				channel.request( 'units' ).add( unit, { merge: true } );
				
				selectedUser.get( 'transientUnits' ).push( unit.get( 'id' ) );
				
				legacyUser.get( 'units' ).remove( legacyUnit );
				
				// show config update view
				let configView = new ConfigView( {
					context: 'update',
				} );
				channelLayout.request( 'root' ).showChildView( 'main', configView );
				
				// unit error listener
				this.listenToOnce( unit, 'error', function ( response ) {
					channelLayout.trigger( 'error', response.responseJSON );
				} );
				
				// unit update listener
				this.listenToOnce( unit, 'updated', function () {
					this.stopListening( unit, 'error' );
					
					// if user has more units, run the legacy layout in migrate mode once more.
					if ( legacyUser.get( 'units' ).length >= 1 ) {
						this._showLegacyFlow( {
							context     : 'migrate',
							selectedUser: selectedUser,
							legacyUser  : legacyUser,
							owner       : owner,
							selectUnit  : true, // force selection of unit, even if there's only one.
						} );
						
						// if user has no more units, show thankyou.
					} else {
						let successView = new SuccessView( {
							context  : 'migrate:complete',
							closeLink: {
								event: 'unit:list',
							},
						} );
						
						this.listenTo( successView, 'success:close', function () {
							successView.animateOut();
						} );
						
						channelLayout.request( 'root' ).showChildView( 'main', successView );
					}
				} );
				
				// listen for unit update
				unit.updateComplete();
			} );
			
			// migrate the unit
			legacyUnit.migrate( {
				customerId: owner.get( 'id' ),
				unitId    : legacyUnit.get( 'unitId' ),
				password  : legacyUser.get( 'password' ),
				userId    : selectedUser.get( 'id' ),
				username  : legacyUser.get( 'user' ),
			} );
		} );
		
		channelLayout.request( 'root' ).showChildView( 'main', legacyFlow );
	},
	
} );

export default LegacyController;